import React from 'react';
import { Loader2 } from 'lucide-react';

interface PullToRefreshIndicatorProps {
  pullDistance: number;
  isRefreshing: boolean;
  threshold?: number;
}

/**
 * Visual indicator for pull-to-refresh action
 */
export const PullToRefreshIndicator: React.FC<PullToRefreshIndicatorProps> = ({
  pullDistance,
  isRefreshing,
  threshold = 80,
}) => {
  if (pullDistance <= 0 && !isRefreshing) return null;

  const progress = Math.min(pullDistance / threshold, 1);
  const rotation = progress * 360;
  const opacity = Math.min(progress * 1.5, 1);

  return (
    <div
      className="flex items-center justify-center overflow-hidden transition-[height] duration-200"
      style={{
        height: `${pullDistance}px`,
      }}
    >
      <div
        className="flex items-center justify-center w-10 h-10 rounded-full bg-bg-primary shadow-md"
        style={{
          opacity,
          transform: isRefreshing ? 'none' : `rotate(${rotation}deg)`,
        }}
      >
        <Loader2
          size={24}
          className={`text-text-primary ${isRefreshing ? 'animate-spin' : ''}`}
        />
      </div>
    </div>
  );
};

export default PullToRefreshIndicator;
